import { render, staticRenderFns } from "./calendar-marker.vue?vue&type=template&id=32b03bc8"
import script from "./calendar-marker.vue?vue&type=script&lang=js"
export * from "./calendar-marker.vue?vue&type=script&lang=js"
import style0 from "./calendar-marker.vue?vue&type=style&index=0&id=32b03bc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports